function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M655 5114 c-11 -2 -45 -9 -75 -15 -217 -44 -429 -224 -522 -444 -56 -133 -53 -12 -53 -2095 0 -2083 -3 -1962 53 -2095 93 -219 290 -387 522 -446 82 -21 3878 -21 3960 0 274 70 491 287 561 561 21 82 21 3878 0 3960 -59 230 -227 429 -441 520 -140 59 19 54 -2070 56 -1053 1 -1924 0 -1935 -2z m2440 -1092 c314 -88 561 -336 646 -647 32 -115 32 -335 0 -450 -85 -312 -333 -560 -646 -647 -75 -20 -105 -22 -462 -26 l-383 -3 0 -540 c0 -521 -1 -541 -20 -579 -36 -70 -70 -80 -280 -80 -210 0 -244 10 -280 80 -20 39 -20 56 -20 1420 0 1364 0 1381 20 1420 12 24 35 48 58 60 36 19 53 20 662 17 613 -3 627 -3 705 -25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2250 3150 l0 -301 348 3 c394 3 398 4 482 88 61 61 85 119 85 210 0 91 -24 149 -85 210 -84 84 -88 85 -482 88 l-348 3 0 -301z"
}));

var SvgParking = function SvgParking(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 511 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgParking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/parking.f64e4582.svg";
export { ForwardRef as ReactComponent };